import { ServiceFieldOptionMessage } from "./ServiceFieldOptionMessage"

export class UpdateServiceFieldMessage {
  name: string
  serviceFieldOptions: ServiceFieldOptionMessage[]

  constructor(name: string, serviceFieldOptions: ServiceFieldOptionMessage[]) {
    this.name = name
    this.serviceFieldOptions = serviceFieldOptions
  }
}
